import React from "react";
import { Col } from "react-bootstrap";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
import { useSelector } from "react-redux";
import di from "../di/serviceLocator";
import Loader from "../../../../../shared-library/components/Loader";
var PartnerMapping = function (props) {
    var mappingDetails = useSelector(function (state) {
        return state.Partners.partnerProfDemMetNomSeg.reducersData.data.mapping;
    });
    var _a = useSelector(function (state) { return state.Partners.partnerProfDemMetNomSeg.commonData; }), overviewLoader = _a.loader, errorData = _a.errorData;
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var selectedPartner = useSelector(function (state) {
        return state.Partners.partnerSummary.reducersData.selectedPartner;
    });
    var getProfileOverviewDetails = function () {
        di.partnerOverview.getPartnerProfDemMetNomSegDetails({
            AcCode: selectedPartner.accountCode,
            flg: selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.flag,
            page: 1,
            pageSize: 100,
        });
    };
    React.useEffect(function () {
        if (!mappingDetails)
            getProfileOverviewDetails();
    }, [mappingDetails, selectedPartner]);
    return (React.createElement(React.Fragment, null, overviewLoader ? (React.createElement("div", { className: "position-relative client-loader" },
        React.createElement(Loader, null))) : (React.createElement("section", { id: "profile-details", className: "section-padding element" },
        React.createElement("label", { className: "DMSanBold_18_700 txt_blackOne1 label-padding" }, "Mapping Details"),
        React.createElement(Col, null,
            React.createElement("div", { className: "d-grid profile-grid" },
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Lob",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(mappingDetails === null || mappingDetails === void 0 ? void 0 : mappingDetails.lob))),
                React.createElement("label", { className: "DMSansMedium_12_500 txt_secondary-gray" },
                    "Sub Lob",
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(mappingDetails === null || mappingDetails === void 0 ? void 0 : mappingDetails.subLob)))))))));
};
export default PartnerMapping;
